import createToaster from '@meforma/vue-toaster/src/api'
let methods = createToaster({
    position: 'top-right',
    duration: 2000
})
const alertres = res => {
    if (typeof res !== "object") {
        return false;
    }
    if (res.status) {
        if (res.text) {
            methods.success(res.text);
        }
    } else {
        if (res.text) {
            methods.error(res.text);
        }
    }
}
export default {
    install: (app) => {
        //Получить настройки
        let fetchGo = async data => {

            if (data.loading) {
                app.config.globalProperties.$swal.showLoading();
            }

            let body = data.body ? data.body : {};
            let method = data.method ? data.method : "POST";
            let credentials = data.credentials ? data.credentials : "include";
            let referrerPolicy = data.referrerPolicy ? data.referrerPolicy : "origin-when-cross-origin";
            let mode = data.mode ? data.mode : "cors";
            let headers = data.headers ? data.headers : {
                Accept: "application/json",
                "Content-Type": "application/json",
                "API-KEY": GCONFIG.APIKEY
            };

            //Если гет запрос то body нельзя передавать
            let b = method === 'POST' ? { body: JSON.stringify(body) } : {};

            let site = data.site !== undefined ? data.site : 'https://admin.standoffhouse.ru';

            let res = await fetch(site + data.url, {
                method: method,
                credentials: credentials,
                referrerPolicy: referrerPolicy,
                mode: mode,
                ...b,
                headers: headers,

            });

            if (data.loading) {
                app.config.globalProperties.$swal.close()
            }

            if (res.status !== 200) {
                alertres({
                    status: false,
                    text: `Ответ от сервера ${res.status}`
                })
                return {}
            }

            try {
                let d = await res.json();
                if (data.alert) alertres(d)
                return d;
            } catch (error) {
                alertres({
                    status: false,
                    text: `Не смогли обработать данные от сервера. Попробуйте позже или обратитесь в техподдержку`
                });
                return {}
            }
        }

        app.config.globalProperties.$fetch = fetchGo;
        app.provide("fetchGo", fetchGo);
    },
};
